import { Authority } from '@/shared/security/authority';
/* tslint:disable */
// prettier-ignore
const Entities = () => import('@/entities/entities.vue');

const TSOrder = () => import('@/entities/ts-order/ts-order.vue');
const TSOrderUpdate = () => import('@/entities/ts-order/ts-order-update.vue');
const TSOrderDetails = () => import('@/entities/ts-order/ts-order-details.vue');

const ACL247WIP = () => import('@/entities/acl-247-wip/acl-247-wip.vue');
const ACL247WIPUpdate = () => import('@/entities/acl-247-wip/acl-247-wip-update.vue');
const ACL247WIPDetails = () => import('@/entities/acl-247-wip/acl-247-wip-details.vue');

const Event = () => import('@/entities/event/event.vue');
const EventUpdate = () => import('@/entities/event/event-update.vue');
const EventDetails = () => import('@/entities/event/event-details.vue');

const MaintenanceHeader = () => import('@/entities/maintenance-header/maintenance-header.vue');
const MaintenanceHeaderUpdate = () => import('@/entities/maintenance-header/maintenance-header-update.vue');
const MaintenanceHeaderDetails = () => import('@/entities/maintenance-header/maintenance-header-details.vue');

const MaintenanceLine = () => import('@/entities/maintenance-line/maintenance-line.vue');
const MaintenanceLineUpdate = () => import('@/entities/maintenance-line/maintenance-line-update.vue');
const MaintenanceLineDetails = () => import('@/entities/maintenance-line/maintenance-line-details.vue');

// SPE Begin use extended components for setup entities
// --- const SqlQuery = () => import('@/entities/sql-query/sql-query.vue');
// --- const SqlQueryUpdate = () => import('@/entities/sql-query/sql-query-update.vue');
// --- const SqlQueryDetails = () => import('@/entities/sql-query/sql-query-details.vue');
const SqlQuery = () => import('@/entities/sql-query/sql-query-extended.vue');
const SqlQueryUpdate = () => import('@/entities/sql-query/sql-query-update-extended.vue');

// --- const ReportGroup = () => import('@/entities/report-group/report-group.vue');
// --- const ReportGroupUpdate = () => import('@/entities/report-group/report-group-update.vue');
// --- const ReportGroupDetails = () => import('@/entities/report-group/report-group-details.vue');
const ReportGroup = () => import('@/entities/report-group/report-group-extended.vue');
const ReportGroupUpdate = () => import('@/entities/report-group/report-group-update-extended.vue');

// --- const ReportCategory = () => import('@/entities/report-category/report-category.vue');
// --- const ReportCategoryUpdate = () => import('@/entities/report-category/report-category-update.vue');
// --- const ReportCategoryDetails = () => import('@/entities/report-category/report-category-details.vue');
const ReportCategory = () => import('@/entities/report-category/report-category-extended.vue');
const ReportCategoryUpdate = () => import('@/entities/report-category/report-category-update-extended.vue');

// --- const Report = () => import('@/entities/report/report.vue');
// --- const ReportUpdate = () => import('@/entities/report/report-update.vue');
// --- const ReportDetails = () => import('@/entities/report/report-details.vue');
const Report = () => import('@/entities/report/report-extended.vue');
const ReportUpdate = () => import('@/entities/report/report-update-extended.vue');

// --- const Config = () => import('@/entities/config/config.vue');
// --- const ConfigUpdate = () => import('@/entities/config/config-update.vue');
// --- const ConfigDetails = () => import('@/entities/config/config-details.vue');
const Config = () => import('@/entities/config/config-extended.vue');
const ConfigUpdate = () => import('@/entities/config/config-update-extended.vue');
// SPE End use extended components for setup entities

// SPE Begin use extended components for calendar entities
// --- const Calendar = () => import('@/entities/calendar/calendar.vue');
// --- const CalendarUpdate = () => import('@/entities/calendar/calendar-update.vue');
// --- const CalendarDetails = () => import('@/entities/calendar/calendar-details.vue');
const Calendar = () => import('@/entities/calendar/calendar-extended.vue');
const CalendarUpdate = () => import('@/entities/calendar/calendar-update-extended.vue');

// --- const CalendarEvent = () => import('@/entities/calendar-event/calendar-event.vue');
// --- const CalendarEventUpdate = () => import('@/entities/calendar-event/calendar-event-update.vue');
// --- const CalendarEventDetails = () => import('@/entities/calendar-event/calendar-event-details.vue');
const CalendarEvent = () => import('@/entities/calendar-event/calendar-event-extended.vue');
const CalendarEventUpdate = () => import('@/entities/calendar-event/calendar-event-update-extended.vue');
const CalendarEventView = () => import('@/entities/spe/go-components/go-gadget-calendar/calendar-event-view.vue');
// SPE End use extended components for calendar entities

// SPE Begin use extended components for society entities
// --- const Society = () => import('@/entities/society/society.vue');
// --- const SocietyUpdate = () => import('@/entities/society/society-update.vue');
// --- const SocietyDetails = () => import('@/entities/society/society-details.vue');
const Society = () => import('@/entities/society/society-extended.vue');
const SocietyUpdate = () => import('@/entities/society/society-update-extended.vue');

// --- const SocietyEquipment = () => import('@/entities/society-equipment/society-equipment.vue');
// --- const SocietyEquipmentUpdate = () => import('@/entities/society-equipment/society-equipment-update.vue');
// --- const SocietyEquipmentDetails = () => import('@/entities/society-equipment/society-equipment-details.vue');
const SocietyEquipment = () => import('@/entities/society-equipment/society-equipment-extended.vue');
const SocietyEquipmentUpdate = () => import('@/entities/society-equipment/society-equipment-update-extended.vue');
// SPE End use extended components for society entities

// SPE Begin use extended components for widget entities
// --- const Widget = () => import('@/entities/widget/widget.vue');
// --- const WidgetUpdate = () => import('@/entities/widget/widget-update.vue');
// --- const WidgetDetails = () => import('@/entities/widget/widget-details.vue');
const Widget = () => import('@/entities/widget/widget-extended.vue');
const WidgetUpdate = () => import('@/entities/widget/widget-update-extended.vue');

// --- const WidgetCategory = () => import('@/entities/widget-category/widget-category.vue');
// --- const WidgetCategoryUpdate = () => import('@/entities/widget-category/widget-category-update.vue');
// --- const WidgetCategoryDetails = () => import('@/entities/widget-category/widget-category-details.vue');
const WidgetCategory = () => import('@/entities/widget-category/widget-category-extended.vue');
const WidgetCategoryUpdate = () => import('@/entities/widget-category/widget-category-update-extended.vue');

// --- const WidgetGallery = () => import('@/entities/widget-gallery/widget-gallery.vue');
// --- const WidgetGalleryUpdate = () => import('@/entities/widget-gallery/widget-gallery-update.vue');
// --- const WidgetGalleryDetails = () => import('@/entities/widget-gallery/widget-gallery-details.vue');
const WidgetGallery = () => import('@/entities/widget-gallery/widget-gallery-extended.vue');
const WidgetGalleryUpdate = () => import('@/entities/widget-gallery/widget-gallery-update-extended.vue');
// SPE End use extended components for widget entities

// SPE Begin use extended components for widget-notification-center
// --- const WidgetNotificationCenter = () => import('@/entities/widget-notification-center/widget-notification-center.vue');
// --- const WidgetNotificationCenterUpdate = () => import('@/entities/widget-notification-center/widget-notification-center-update.vue');
// --- const WidgetNotificationCenterDetails = () => import('@/entities/widget-notification-center/widget-notification-center-details.vue');
const WidgetNotificationCenter = () => import('@/entities/widget-notification-center/widget-notification-center-extended.vue');
const WidgetNotificationCenterUpdate = () => import('@/entities/widget-notification-center/widget-notification-center-update-extended.vue');
// SPE End use extended components for widget-notification-center

// SPE Begin use extended components for society-group
// --- const SocietyGroup = () => import('@/entities/society-group/society-group.vue');
// --- const SocietyGroupUpdate = () => import('@/entities/society-group/society-group-update.vue');
const SocietyGroup = () => import('@/entities/society-group/society-group-extended.vue');
const SocietyGroupUpdate = () => import('@/entities/society-group/society-group-update-extended.vue');
const SocietyGroupDetails = () => import('@/entities/society-group/society-group-details.vue');
// SPE End use extended components for society-group

const BookableEvent = () => import('@/entities/bookable-event/bookable-event.vue');
const BookableEventUpdate = () => import('@/entities/bookable-event/bookable-event-update.vue');
const BookableEventDetails = () => import('@/entities/bookable-event/bookable-event-details.vue');

const EventSlot = () => import('@/entities/event-slot/event-slot.vue');
const EventSlotUpdate = () => import('@/entities/event-slot/event-slot-update.vue');
const EventSlotDetails = () => import('@/entities/event-slot/event-slot-details.vue');

const EventRegistration = () => import('@/entities/event-registration/event-registration.vue');
const EventRegistrationUpdate = () => import('@/entities/event-registration/event-registration-update.vue');
const EventRegistrationDetails = () => import('@/entities/event-registration/event-registration-details.vue');

const EventWaitlist = () => import('@/entities/event-waitlist/event-waitlist.vue');
const EventWaitlistUpdate = () => import('@/entities/event-waitlist/event-waitlist-update.vue');
const EventWaitlistDetails = () => import('@/entities/event-waitlist/event-waitlist-details.vue');

const Menu = () => import('@/entities/menu/menu.vue');
const MenuUpdate = () => import('@/entities/menu/menu-update.vue');
const MenuDetails = () => import('@/entities/menu/menu-details.vue');

const MenuItem = () => import('@/entities/menu-item/menu-item.vue');
const MenuItemUpdate = () => import('@/entities/menu-item/menu-item-update.vue');
const MenuItemDetails = () => import('@/entities/menu-item/menu-item-details.vue');

// jhipster-needle-add-entity-to-router-import - JHipster will import entities to the router here

// SPE Begin widget-sidebar viewer route
const WidgetSideBar = () => import('@/entities/spe/go-components/widget-sidebar/widget-sidebar.vue');
// SPE End widget-sidebar viewer route

// SPE Begin menu-admin route
const MenuAdmin = () => import('@/entities/spe/menu-admin/menu-admin.vue');
// SPE End menu-admin route

export default {
  path: '/',
  component: Entities,
  children: [
    {
      path: 'ts-order',
      name: 'TSOrder',
      component: TSOrder,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'ts-order/new',
      name: 'TSOrderCreate',
      component: TSOrderUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'ts-order/:tSOrderId/edit',
      name: 'TSOrderEdit',
      component: TSOrderUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'ts-order/:tSOrderId/view',
      name: 'TSOrderView',
      component: TSOrderDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'acl-247-wip',
      name: 'ACL247WIP',
      component: ACL247WIP,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'acl-247-wip/new',
      name: 'ACL247WIPCreate',
      component: ACL247WIPUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'acl-247-wip/:aCL247WIPId/edit',
      name: 'ACL247WIPEdit',
      component: ACL247WIPUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'acl-247-wip/:aCL247WIPId/view',
      name: 'ACL247WIPView',
      component: ACL247WIPDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'event',
      name: 'Event',
      component: Event,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'event/new',
      name: 'EventCreate',
      component: EventUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'event/:eventId/edit',
      name: 'EventEdit',
      component: EventUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'event/:eventId/view',
      name: 'EventView',
      component: EventDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'maintenance-header',
      name: 'MaintenanceHeader',
      component: MaintenanceHeader,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'maintenance-header/new',
      name: 'MaintenanceHeaderCreate',
      component: MaintenanceHeaderUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'maintenance-header/:maintenanceHeaderId/edit',
      name: 'MaintenanceHeaderEdit',
      component: MaintenanceHeaderUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'maintenance-header/:maintenanceHeaderId/view',
      name: 'MaintenanceHeaderView',
      component: MaintenanceHeaderDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'maintenance-line',
      name: 'MaintenanceLine',
      component: MaintenanceLine,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'maintenance-line/new',
      name: 'MaintenanceLineCreate',
      component: MaintenanceLineUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'maintenance-line/:maintenanceLineId/edit',
      name: 'MaintenanceLineEdit',
      component: MaintenanceLineUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'maintenance-line/:maintenanceLineId/view',
      name: 'MaintenanceLineView',
      component: MaintenanceLineDetails,
      meta: { authorities: [Authority.USER] },
    },
    // SPE Begin setup entity routes with extended components
    {
      path: 'sql-query',
      name: 'SqlQuery',
      component: SqlQuery,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'sql-query/new',
      name: 'SqlQueryCreate',
      component: SqlQueryUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'sql-query/:sqlQueryId/edit',
      name: 'SqlQueryEdit',
      component: SqlQueryUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'sql-query/:sqlQueryId/view',
      name: 'SqlQueryView',
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'sql-query/:sqlQueryId/duplicate',
      name: 'SqlQueryDuplicate',
      component: SqlQueryUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'report-group',
      name: 'ReportGroup',
      component: ReportGroup,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'report-group/new',
      name: 'ReportGroupCreate',
      component: ReportGroupUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'report-group/:reportGroupId/edit',
      name: 'ReportGroupEdit',
      component: ReportGroupUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'report-group/:reportGroupId/duplicate',
      name: 'ReportGroupDuplicate',
      component: ReportGroupUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'report-category',
      name: 'ReportCategory',
      component: ReportCategory,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'report-category/new',
      name: 'ReportCategoryCreate',
      component: ReportCategoryUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'report-category/:reportCategoryId/edit',
      name: 'ReportCategoryEdit',
      component: ReportCategoryUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'report-category/:reportCategoryId/duplicate',
      name: 'ReportCategoryDuplicate',
      component: ReportCategoryUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'report',
      name: 'Report',
      component: Report,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'report/new',
      name: 'ReportCreate',
      component: ReportUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'report/:reportId/edit',
      name: 'ReportEdit',
      component: ReportUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'report/:reportId/duplicate',
      name: 'ReportDuplicate',
      component: ReportUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'config',
      name: 'Config',
      component: Config,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'config/new',
      name: 'ConfigCreate',
      component: ConfigUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'config/:configId/edit',
      name: 'ConfigEdit',
      component: ConfigUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'config/:configId/duplicate',
      name: 'ConfigDuplicate',
      component: ConfigUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    // SPE End setup entity routes with extended components
    // SPE Begin calendar entity routes with extended components
    {
      path: 'calendar',
      name: 'Calendar',
      component: Calendar,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'calendar/new',
      name: 'CalendarCreate',
      component: CalendarUpdate,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'calendar/:calendarId/edit',
      name: 'CalendarEdit',
      component: CalendarUpdate,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'calendar/:calendarId/events',
      name: 'CalendarEvent',
      component: CalendarEvent,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'calendar/events/view',
      name: 'CalendarEventView',
      component: CalendarEventView,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'calendar/:calendarId/events/view',
      name: 'CalendarEventViewById',
      component: CalendarEventView,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'calendar/:calendarId/duplicate',
      name: 'CalendarDuplicate',
      component: CalendarUpdate,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'calendar-event/:calendarEventId/edit',
      name: 'SpeCalendarEventEdit',
      component: CalendarEventUpdate,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    // SPE End calendar entity routes with extended components
    // SPE Begin society entity routes with extended components
    {
      path: 'society',
      name: 'Society',
      component: Society,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'society/new',
      name: 'SocietyCreate',
      component: SocietyUpdate,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'society/:societyId/edit',
      name: 'SocietyEdit',
      component: SocietyUpdate,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'society/:societyId/duplicate',
      name: 'SocietyDuplicate',
      component: SocietyUpdate,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'society-equipment',
      name: 'SocietyEquipment',
      component: SocietyEquipment,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'society-equipment/new',
      name: 'SocietyEquipmentCreate',
      component: SocietyEquipmentUpdate,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'society-equipment/:societyEquipmentId/edit',
      name: 'SocietyEquipmentEdit',
      component: SocietyEquipmentUpdate,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'society-equipment/:societyEquipmentId/duplicate',
      name: 'SocietyEquipmentDuplicate',
      component: SocietyEquipmentUpdate,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    // SPE End society entity routes with extended components
    // SPE Begin widget entity routes with extended components
    {
      path: 'widget',
      name: 'Widget',
      component: Widget,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'widget/new',
      name: 'WidgetCreate',
      component: WidgetUpdate,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'widget/:widgetId/edit',
      name: 'WidgetEdit',
      component: WidgetUpdate,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'widget/:widgetId/duplicate',
      name: 'WidgetDuplicate',
      component: WidgetUpdate,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'widget-category',
      name: 'WidgetCategory',
      component: WidgetCategory,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'widget-category/new',
      name: 'WidgetCategoryCreate',
      component: WidgetCategoryUpdate,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'widget-category/:widgetCategoryId/edit',
      name: 'WidgetCategoryEdit',
      component: WidgetCategoryUpdate,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'widget-category/:widgetCategoryId/duplicate',
      name: 'WidgetCategoryDuplicate',
      component: WidgetCategoryUpdate,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'widget-gallery',
      name: 'WidgetGallery',
      component: WidgetGallery,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'widget-gallery/new',
      name: 'WidgetGalleryCreate',
      component: WidgetGalleryUpdate,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'widget-gallery/:widgetGalleryId/edit',
      name: 'WidgetGalleryEdit',
      component: WidgetGalleryUpdate,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'widget-gallery/:widgetGalleryId/duplicate',
      name: 'WidgetGalleryDuplicate',
      component: WidgetGalleryUpdate,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    // SPE End widget entity routes with extended components
    // SPE Begin widget-notification-center routes with extended components
    {
      path: 'widget-notification-center',
      name: 'WidgetNotificationCenter',
      component: WidgetNotificationCenter,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'widget-notification-center/new',
      name: 'WidgetNotificationCenterCreate',
      component: WidgetNotificationCenterUpdate,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'widget-notification-center/:widgetNotificationCenterId/edit',
      name: 'WidgetNotificationCenterEdit',
      component: WidgetNotificationCenterUpdate,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'widget-notification-center/:widgetNotificationCenterId/duplicate',
      name: 'WidgetNotificationCenterDuplicate',
      component: WidgetNotificationCenterUpdate,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    // SPE End widget-notification-center routes with extended components
    // SPE Begin society-group entity routes with extended components
    {
      path: 'society-group',
      name: 'SocietyGroup',
      component: SocietyGroup,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'society-group/new',
      name: 'SocietyGroupCreate',
      component: SocietyGroupUpdate,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'society-group/:societyGroupId/edit',
      name: 'SocietyGroupEdit',
      component: SocietyGroupUpdate,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'society-group/:societyGroupId/duplicate',
      name: 'SocietyGroupDuplicate',
      component: SocietyGroupUpdate,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    {
      path: 'society-group/:societyGroupId/view',
      name: 'SocietyGroupView',
      component: SocietyGroupDetails,
      meta: { authorities: [Authority.ADMIN, Authority.DASHBOARD_ADMIN] },
    },
    // SPE End society-group entity routes with extended components
    // SPE Begin widget-sidebar viewer route
    {
      path: 'spe/widget-sidebar',
      name: 'WidgetSideBar',
      component: WidgetSideBar,
      meta: { authorities: [Authority.USER] },
    },
    // SPE End widget-sidebar viewer route
    {
      path: 'bookable-event',
      name: 'BookableEvent',
      component: BookableEvent,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'bookable-event/new',
      name: 'BookableEventCreate',
      component: BookableEventUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'bookable-event/:bookableEventId/edit',
      name: 'BookableEventEdit',
      component: BookableEventUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'bookable-event/:bookableEventId/view',
      name: 'BookableEventView',
      component: BookableEventDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'event-slot',
      name: 'EventSlot',
      component: EventSlot,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'event-slot/new',
      name: 'EventSlotCreate',
      component: EventSlotUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'event-slot/:eventSlotId/edit',
      name: 'EventSlotEdit',
      component: EventSlotUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'event-slot/:eventSlotId/view',
      name: 'EventSlotView',
      component: EventSlotDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'event-registration',
      name: 'EventRegistration',
      component: EventRegistration,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'event-registration/new',
      name: 'EventRegistrationCreate',
      component: EventRegistrationUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'event-registration/:eventRegistrationId/edit',
      name: 'EventRegistrationEdit',
      component: EventRegistrationUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'event-registration/:eventRegistrationId/view',
      name: 'EventRegistrationView',
      component: EventRegistrationDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'event-waitlist',
      name: 'EventWaitlist',
      component: EventWaitlist,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'event-waitlist/new',
      name: 'EventWaitlistCreate',
      component: EventWaitlistUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'event-waitlist/:eventWaitlistId/edit',
      name: 'EventWaitlistEdit',
      component: EventWaitlistUpdate,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'event-waitlist/:eventWaitlistId/view',
      name: 'EventWaitlistView',
      component: EventWaitlistDetails,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: 'menu',
      name: 'Menu',
      component: Menu,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'menu/new',
      name: 'MenuCreate',
      component: MenuUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'menu/:menuId/edit',
      name: 'MenuEdit',
      component: MenuUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'menu/:menuId/view',
      name: 'MenuView',
      component: MenuDetails,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'menu-item',
      name: 'MenuItem',
      component: MenuItem,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'menu-item/new',
      name: 'MenuItemCreate',
      component: MenuItemUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'menu-item/:menuItemId/edit',
      name: 'MenuItemEdit',
      component: MenuItemUpdate,
      meta: { authorities: [Authority.ADMIN] },
    },
    {
      path: 'menu-item/:menuItemId/view',
      name: 'MenuItemView',
      component: MenuItemDetails,
      meta: { authorities: [Authority.ADMIN] },
    },
    // SPE Begin menu-admin route
    {
      path: '/setup/menus',
      name: 'MenuAdmin',
      component: MenuAdmin,
      meta: { authorities: [Authority.ADMIN] },
    },
    // SPE End menu-admin route
    // jhipster-needle-add-entity-to-router - JHipster will add entities to the router here
  ],
};
